import * as React from 'react';
import { ActorApiStringDisplay } from '../../../../../../components/display/string';
import { useAccountPositionsHistoryHisMvtHitHdc } from '../../hooks';

export const AccountsPositionsHistoryHisMvtHitHdcSign = () => {
  const {
    data,
    isLoading,
    error,
  } = useAccountPositionsHistoryHisMvtHitHdc();
  return (
    <ActorApiStringDisplay
      data={data}
      isLoading={isLoading}
      error={error}
      loadingValue="-"
    />
  );
};
